import React from 'react';

const Button = ({ children, variant = 'primary', size = 'normal', className = '', onClick, icon: Icon, disabled = false }) => {
  const baseStyle = "flex items-center justify-center font-medium transition-all duration-200 active:scale-95";
  
  const variants = {
    primary: `bg-[#3182CE] text-white shadow-md hover:bg-[#2B6CB0]`,
    secondary: `bg-white border border-[#EDF2F7] text-[#4A5568] shadow-sm hover:bg-gray-50`,
    danger: `bg-white border border-red-100 text-red-500 hover:bg-red-50`,
    text: `text-[#3182CE] bg-transparent hover:bg-blue-50`,
    icon: `text-[#3182CE] hover:bg-blue-50 rounded-full`
  };

  const sizes = {
    small: "px-3 py-1.5 text-xs rounded-lg",
    normal: "px-4 py-2 text-sm rounded-xl",
    large: "px-6 py-3 text-base rounded-xl",
    icon: "p-2"
  };

  const selectedVariant = variants[variant] || variants.primary;
  const selectedSize = variant === 'icon' ? sizes.icon : sizes[size];
  const disabledStyle = disabled ? "opacity-50 cursor-not-allowed grayscale pointer-events-none" : "";

  return (
    <button 
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`${baseStyle} ${selectedVariant} ${selectedSize} ${disabledStyle} ${className}`}
    >
      {Icon && <Icon size={16} className={children ? "mr-2" : ""} />}
      {children}
    </button>
  );
};

export default Button;
